import { apiError } from "@/lib/api";
import { toast } from "sonner";

export const sel = "h-11 rounded-xl border border-slate-300 bg-white px-3 text-sm";
export const inp = "h-11 rounded-xl border border-slate-300 bg-white px-3 text-sm";

export const localISO = (offsetDays = 0) => { const d = new Date(Date.now() + offsetDays * 864e5); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };

export const err = (e) => {
  const d = e?.response?.data?.detail;
  toast.error(typeof d === "object" && d?.message ? d.message : apiError(d));
  return d;
};

export const CodeChip = ({ code, color, testid }) => (
  <span data-testid={testid} className="inline-flex min-w-9 justify-center rounded-md px-1.5 py-0.5 text-[11px] font-extrabold text-white" style={{ background: color || "#64748b" }}>{code || "—"}</span>
);

export const Card = ({ children, testid, className = "" }) => <div data-testid={testid} className={`rounded-2xl border border-slate-200 bg-white p-4 ${className}`}>{children}</div>;

export const PersonSelect = ({ people, value, onChange, testid }) => (
  <select data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)} className={`${sel} w-full sm:w-64`}>
    <option value="">Choisir un salarié…</option>
    {people.map((p) => <option key={p.user_id} value={p.user_id}>{p.name}</option>)}
  </select>
);
